module.exports = "query discountCode($group: String) { discountCode(group: $group) }"